import { JSX, lazy } from "react";
import { BrowserRouter, Navigate, Route, } from "react-router-dom";
import RoutesWithNotFound from "../components/RoutesWithNotFound";
/* import { PrivateRouter } from "@/private/PrivateRouter"; */
import { PrivateGuard } from "../guards/PrivateGuard";

const LoginContainer = lazy(() => import("@/public/modules/login/LoginContainer"));

const AppRouting = (): JSX.Element => (
    <BrowserRouter>
        <RoutesWithNotFound>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/login" element={<LoginContainer />} />
            <Route element={<PrivateGuard />}>
                {/* <Route path={`/*`} element={<PrivateRouter />} /> */}
            </Route>
        </RoutesWithNotFound>
    </BrowserRouter>
);

export default AppRouting;